import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { lighten } from 'polished';

export const Container = styled.div`
  padding: 20px;
  height: calc(100vh - 48px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  width: 100%;
  padding: 20px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 8px;
  justify-content: center;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 0 5px 1px rgba(0, 0, 0, 0.1);
  transition: border-radius 0.2s;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }

  svg {
    color: ${(props) => props.theme.colors.tertiary};
    margin-right: 10px;
  }
`;

export const StyledA = styled.a`
  &:hover {
    text-decoration: none;
  }

  svg {
    color: ${(props) => props.theme.colors.tertiary};
    margin-right: 10px;
  }
`;

export const TablesTable = styled.table`
  width: 100%;
  border-collapse: initial;
  border-spacing: 0 20px;
  background: #e9ecf2;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 0 30px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid #a8b4cc;
      padding-bottom: 10px;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;

export const CategoryHeader = styled.div`
  margin-left: 50px;
  margin-bottom: 20px;
`;

export const ProductImage = styled.img`
  width: 80px;
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const Actions = styled.div``;

export const DisplayNoneImprimir = styled.button`
  display: none;
`;

export const ContainerFormModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Print = styled.button`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  align-self: center;
  margin-right: 10px;
  border: none;
  background: #d60300;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
    border: solid grey 1px;
    border-radius: 50%;
  }
`;

export const StatusTag = styled.div.attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundcolor};
  font-weight: bold;
  padding: 5px 10px;
  max-width: 150px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  &::before {
    content: ' ';
    display: inline-block;
    position: relative;
    margin-right: 5px;
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.color};
    border-radius: 50%;
  }
`;

export const EditButton = styled(Link)`
  height: 25px;
  border-radius: 8px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  color: white;
  align-self: center;
  margin-right: 15px;
  border: none;
  background: #17a2b8;
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  text-align: center;
  margin-bottom: 6px;
  width: 80%;

  :hover {
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.4));
    text-decoration: none;
    color: white;
  }
  div {
    margin: auto;
    text-align: center;
  }
`;

export const DeleteAndEditActions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleModal = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: ${({ title }) => (title ? '18px' : '16px')};
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  letter-spacing: var(--Headline-Small-Tracking, 0);
`;

export const ItemsMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  gap: 12px;
  align-self: stretch;
  border-top: 1px solid #ededed;
`;

export const AllItemsContainer = styled.div`
  max-height: 320px;
  overflow-y: auto;
  border-radius: 8px;
  background: white;
`;

export const AllItems = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const HeaderAllItems = styled.div`
  display: flex;
  height: 48px;
  width: 100%;
  align-items: center;
  background: #efefef;
  font-weight: 500;
  font-size: 14px;
  color: #222222;
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const ItemsList = styled.div`
  overflow-y: auto;
  max-height: calc(320px - 48px);
`;

export const CategoryRow = styled.div`
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: stretch;
  &:hover {
    background-color: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const ChevronClickableArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 6px 14px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #e9ecef;
  }
`;

export const ProductRow = styled.div`
  transition: background-color 0.2s ease;
  cursor: pointer;
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const ProductClickableWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  cursor: pointer;
`;

export const CheckboxInputStyled = styled.div`
  input[type='checkbox'] {
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #2ec9b7;
    width: 17px;
    height: 17px;
    border: 0.15em solid #222222;
    border-radius: 0.15em;
    transform: translateY(-0.075em);
    display: grid;
    place-content: center;
    margin-right: 8px;
  }

  input[type='checkbox']::before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #2ec9b7;
    transform-origin: bottom left;

    clip-path: ${(props) =>
      props.allChecksChecked
        ? 'inset(50% 20% 44% 10%);'
        : 'polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%)'};
  }

  input[type='checkbox']:checked::before {
    transform: scale(1);
    background-color: #2ec9b7;
  }

  .form-control + .form-control {
    margin-top: 1em;
  }

  input[type='checkbox']:disabled {
    color: #3c3c3c;
    cursor: not-allowed;
  }
`;
export const HeaderProduct = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  color: #222222;
`;

export const Categorie = styled.div`
  display: flex;
  height: 48px;
  padding: 12px 16px 12px 48px;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  color: #222222;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  position: relative;

  ${({ isIndeterminate }) =>
    isIndeterminate &&
    `
    &::after {
      content: '−';
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      font-weight: bold;
      color: #2ec9b7;
      pointer-events: none;
      z-index: 1;
    }
  `}
`;

export const HeaderCheckboxWrapper = styled(CheckboxWrapper)`
  width: 100%;
  height: 100%;
  margin-left: 6px;
  padding: 12px 6px;
  * {
    pointer-events: none;
  }
  pointer-events: auto;
`;

export const CategoryCheckboxWrapper = styled(CheckboxWrapper)`
  flex: 1;
  padding: 14px 16px 14px 6px;
  * {
    pointer-events: none;
  }
  pointer-events: auto;
`;

export const ProductCheckboxWrapper = styled(CheckboxWrapper)`
  flex: 1;
  height: 48px;
  padding: 14px 16px 14px 48px;
  * {
    pointer-events: none;
  }
  pointer-events: auto;
`;

export const ContainerSwitchs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
`;
export const ContainerDelete = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  width: 100%;
`;

export const ContainerTrash = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  width: 100%;
`;

export const TextTrash = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  letter-spacing: var(--Headline-Small-Tracking, 0);
`;

export const HeaderPrinterDelete = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  width: 100%;
`;

export const NamePrinter = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Label/Label Large/Regular | 400 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.014px;
`;

export const FooterPrinterDelete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  width: 100%;
`;
